import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Grid, CircularProgress } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import { useNavigate } from "react-router-dom";
import config from "../config";
import { LoginForm, LoginLogo, Toaster } from "../common/components";
import styles from "./styles";
import { useBranding } from "../common/hooks";
import { db } from "../common/lib";
import { update } from "idb-keyval";
/**
 * Login Component
 */
export default () => {
    const { appSettings } = useSelector((state) => state);
    let navigate = useNavigate();
    const classes = makeStyles(styles)();
    const { loginLogo } = useBranding();
    const [logo, setLoginLogo] = useState("");

    /** clear redux cache */
    useEffect(() => {
        // update(db.types.reduxState, () => []);
        update(db.types.typesList, () => []);
    }, []);

    useEffect(() => {
        //setLogo
        setLoginLogo(loginLogo);
    }, [appSettings, loginLogo]);

    const onSuccess = () => navigate(`/${config.paths.auth}`);

    return (
        <>
            <Grid
                alignItems="center"
                className={classes.loginContainer}
                container
                direction="column"
                justifyContent="center"
            >
                {logo && logo.length > 0 ? (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        className={classes.logoContainer}
                    >
                        <LoginLogo height={96} light url={logo} />
                    </Grid>
                ) : (
                    <CircularProgress color="secondary" size={32} />
                )}
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.formContainer}
                >
                    <LoginForm onSuccess={onSuccess} />
                </Grid>
            </Grid>
            <Toaster />
        </>
    );
};
